// extracted by mini-css-extract-plugin
module.exports = {"MobileBiasModal":"MobileBiasModal_MobileBiasModal__pG9un","MobileBiasModalOverlay":"MobileBiasModal_MobileBiasModalOverlay__ruo9E"};